import { create } from 'zustand';

interface ProjectFileState {
  fileHandle: FileSystemFileHandle | null;
  savedFileName: string | null;
  setSaveTarget: (fileHandle: FileSystemFileHandle | null, savedFileName: string | null) => void;
  clearSaveTarget: () => void;
}

export const useProjectStore = create<ProjectFileState>((set) => ({
  fileHandle: null,
  savedFileName: null,
  setSaveTarget: (fileHandle, savedFileName) => set({ fileHandle, savedFileName }),
  clearSaveTarget: () => set({ fileHandle: null, savedFileName: null }),
}));

export function hasSaveTarget(state: Pick<ProjectFileState, 'fileHandle' | 'savedFileName'>): boolean {
  return state.fileHandle !== null || state.savedFileName !== null;
}
